import { render, staticRenderFns } from "./planAddModel.vue?vue&type=template&id=0f46c07a&scoped=true&"
import script from "./planAddModel.vue?vue&type=script&lang=js&"
export * from "./planAddModel.vue?vue&type=script&lang=js&"
import style0 from "./planAddModel.vue?vue&type=style&index=0&id=0f46c07a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f46c07a",
  null
  
)

export default component.exports